import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import { gsap } from 'gsap'
import CustomEase from 'gsap/dist/CustomEase'
import { MCalculatorRingsGraphic } from '../molecules/m-calculator-rings-graphic'

type Props = {
  className?: string
  questions: number
  currentQuestion: number
  onShowResults: () => void
}

export const CResultCalculator = ({
  questions,
  currentQuestion,
  onShowResults,
}: Props) => {
  const { t } = useTranslation('common')
  const [percent, setPercent] = useState<number>(0)

  const value = {
    val: 0,
  }

  useEffect(() => {
    if (currentQuestion >= questions) {
      gsap.to(value, {
        duration: 6,
        delay: 0.5,
        ease: CustomEase.create(
          'custom',
          'M0,0 C0.362,0.098 0.689,0.907 0.772,0.692 0.722,0.752 0.868,1.001 1,1 '
        ),
        val: 100,
        onUpdate: () => {
          setPercent(value.val)
        },
        roundProps: 'val',
        onComplete: onShowResults,
      })
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center px-5 pt-24 pb-24 md:py-56 text-primary-teal md:px-10 lg:mt-32">
      <MCalculatorRingsGraphic />
      <span className="text-4xl md:text-6xl">{percent}%</span>
      <span className="text-center text-charcoal">
        {t('calculating-your-ideal-vision')}
        <br />
        {t('correction-procedure')}...
      </span>
    </div>
  )
}
